var chunkToChildrenMap = {
	"22": [
		2525
	],
	"213": [
		6939
	],
	"2079": [
		2525
	],
	"2226": [
		2525
	],
	"2424": [
		7159
	],
	"2654": [
		2525,
		2703
	],
	"6450": [
		2525
	],
	"7049": [
		2525,
		4202
	],
	"7846": [
		2525
	],
	"8558": [
		4019,
		319,
		5400,
		7412,
		2758,
		7431,
		8437,
		6974,
		2226
	],
	"8874": [
		2525,
		2703,
		9862
	],
	"9568": [
		2525,
		9845
	],
	"9632": [
		2525
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));